export type BlockContent = {
  _uid: string
  component: string
} & Record<string, unknown>

// TODO other checks, such as check for uid
export const isBlockContent = (data: unknown): data is BlockContent =>
  typeof data === 'object' &&
  data !== null &&
  '_uid' in data &&
  typeof data._uid === 'string' &&
  'component' in data &&
  typeof data.component === 'string'

export const isBlocksContent = (data: unknown): data is BlockContent[] =>
  Array.isArray(data) && data.every(isBlockContent)
